/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoFigmaIcon20Solid = forwardRef('LogoFigmaIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M5 4.5A2.5 2.5 0 0 1 7.5 2H10v5H7.5A2.5 2.5 0 0 1 5 4.5Z" }),
        React.createElement("path", { d: "M5 10.5A2.5 2.5 0 0 1 7.5 8H10v5H7.5A2.5 2.5 0 0 1 5 10.5Z" }),
        React.createElement("path", { d: "M16 10.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z" }),
        React.createElement("path", { d: "M7.5 14a2.5 2.5 0 1 0 2.5 2.5V14H7.5Z" }),
        React.createElement("path", { d: "M13.5 2H11v5h2.5a2.5 2.5 0 0 0 0-5Z" })));
});
